import { render, staticRenderFns } from "./BreadcrumbsNew.vue?vue&type=template&id=327693dc&"
import script from "./BreadcrumbsNew.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports